import { getRecentPosts } from "@/lib/api/discover"
import { DataSource } from "./base"
import { DataSourcePagination } from "../types"
import { TrendingEntry } from "@/types/farcaster"

/**
 * DataSource for fetching recent posts.
 *
 * On the backend, we have basic heuristics to determine what is
 * considered high enough quality to be considered "recent".
 */
export default class RecentDataSource implements DataSource {
  async fetchMore(props?: DataSourcePagination) {
    const data = await getRecentPosts(props?.cursor, undefined)

    const pagination = this.updatePagination({
      currentPagination: props,
      newData: data,
    })

    return { data, pagination }
  }

  getInitialPagination() {
    return { cursor: undefined }
  }

  updatePagination(props?: {
    currentPagination?: DataSourcePagination
    newData: TrendingEntry[]
  }) {
    const lastPost = props?.newData[props.newData.length - 1]
    return {
      cursor: lastPost
        ? {
            publishedAt: Number(lastPost.post.publishedAt),
            id: lastPost.post.id,
          }
        : undefined,
    }
  }
}
